"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const visibility_off_icon_svg_1 = __importDefault(require("../../assets/images/icons/visibility-off-icon.svg"));
const visibility_on_icon_svg_1 = __importDefault(require("../../assets/images/icons/visibility-on-icon.svg"));
require("./baseInput.scss");
const baseInputTypes_1 = require("./baseInputTypes");
const success_input_icon_svg_1 = __importDefault(require("../../assets/images/icons/success-input-icon.svg"));
const error_input_icon_svg_1 = __importDefault(require("../../assets/images/icons/error-input-icon.svg"));
const info_input_icon_svg_1 = __importDefault(require("../../assets/images/icons/info-input-icon.svg"));
const search_input_icon_svg_1 = __importDefault(require("../../assets/images/icons/search-input-icon.svg"));
const react_2 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const master_1 = require("../../constants/master");
const react_svg_1 = require("react-svg");
const StyledInput = styled_components_1.default.div `
  .base-input {
    border: 2px solid ${(props) => props.primaryColor} !important;
  }

  .base-input::placeholder {
    color: ${(props) => props.primaryColor} !important;
  }
  .customizable-icon .injected-svg {
    fill: ${(props) => props.primaryColor} !important;
    stroke: none !important;
  }
`;
function Input(props) {
    var _a, _b;
    // input ref variable
    const inputRef = (0, react_1.useRef)(null);
    const wrapperRef = (0, react_1.useRef)(null);
    const [inputType, setInputType] = (0, react_1.useState)(props.type);
    function getPrefixSuffixIconByEnum(iconEnum) {
        switch (iconEnum) {
            case baseInputTypes_1.InputSuffixIcon.success:
                return success_input_icon_svg_1.default;
            case baseInputTypes_1.InputSuffixIcon.error:
                return error_input_icon_svg_1.default;
            case baseInputTypes_1.InputSuffixIcon.info:
                return info_input_icon_svg_1.default;
            case baseInputTypes_1.InputSuffixIcon.search:
                return search_input_icon_svg_1.default;
            default:
                return success_input_icon_svg_1.default;
        }
    }
    function isCharacterErrorActive() {
        if (props.isErrorActive) {
            return true;
        }
        if (props.characterCounterOptions &&
            props.value &&
            props.value.toString().length >
                props.characterCounterOptions.maxCharachters) {
            return true;
        }
        else {
            return false;
        }
    }
    const config = (0, master_1.getMasterConfig)();
    return (react_2.default.createElement(StyledInput, { className: "base-input-general flex-column ai-fs", ref: wrapperRef, style: Object.assign({}, props.wrapperStyles), primaryColor: config.primaryColor },
        react_2.default.createElement("div", { className: "flex-row visibility-row", style: {
                position: props.visibilityToggleEnabled ||
                    props.suffixIcon ||
                    props.prefixIcon
                    ? "relative"
                    : "static",
            } },
            react_2.default.createElement("input", { type: inputType, ref: inputRef, value: props.value, maxLength: (_a = props.characterCounterOptions) === null || _a === void 0 ? void 0 : _a.maxCharachters, onChange: (e) => {
                    if (props.onChangeAction) {
                        props.onChangeAction(e.target.value);
                    }
                }, onKeyPress: props.onKeyPressAction, onFocus: props.onFocusAction, onBlur: props.onBlurAction, placeholder: props.placeholder, className: `base-input flex-row  ${isCharacterErrorActive() ? "error" : ""} ${props.successStateOptions ? "success" : ""} ${props.className ? props.className : ""}`, style: Object.assign({ minWidth: `${props.width}px`, maxWidth: `${props.width}px`, minHeight: `${props.height}px`, maxHeight: `${props.height}px` }, props.styles) }),
            props.visibilityToggleEnabled && (react_2.default.createElement(react_svg_1.ReactSVG, { src: inputType === "password" ? visibility_on_icon_svg_1.default : visibility_off_icon_svg_1.default, style: Object.assign({ right: props.suffixIcon ? "40px" : "15px" }, props.visibilityButtonStyles), onClick: () => {
                    setInputType(inputType === "password" ? "text" : "password");
                }, className: "customizable-icon visibility-button" })),
            props.suffixIcon && (react_2.default.createElement("img", { className: "suffix-icon", src: getPrefixSuffixIconByEnum(props.suffixIcon), height: 15, width: 15, alt: "suffix-icon" })),
            props.prefixIcon && (react_2.default.createElement("img", { className: "prefix-icon", src: getPrefixSuffixIconByEnum(props.prefixIcon), height: 15, width: 15, alt: "prefix-icon" })),
            props.characterCounterOptions && (react_2.default.createElement("span", { className: "character-counter", style: Object.assign(Object.assign({ height: props.characterCounterOptions ? undefined : `17px`, maxWidth: `${props.width}px` }, props.characterCounterOptions.characterCounterStyles), { color: props.value &&
                        props.value.toString().length >
                            props.characterCounterOptions.maxCharachters
                        ? "red"
                        : undefined }) }, (_b = props.value) === null || _b === void 0 ? void 0 :
                _b.toString().length,
                "/",
                props.characterCounterOptions.maxCharachters))),
        props.isErrorActive && (react_2.default.createElement("span", { className: "error-text", style: Object.assign({ height: props.isErrorActive ? undefined : `17px`, maxWidth: `${props.width}px` }, props.errorTextStyles) }, props.errorText)),
        !props.isErrorActive && props.successStateOptions && (react_2.default.createElement("span", { className: "success-text", style: {
                height: props.successStateOptions ? undefined : `17px`,
                maxWidth: `${props.width}px`,
            } }, props.successStateOptions.successText)),
        !props.isErrorActive &&
            props.successStateOptions == null &&
            props.helperText && (react_2.default.createElement("span", { className: "helper-text", style: {
                height: props.helperText != null ? undefined : `17px`,
                maxWidth: `${props.width}px`,
            } }, props.helperText))));
}
exports.default = Input;
